import { ApolloProvider } from "@apollo/client";
import apolloClient from "@apolloConfigs/apolloClient";
import {
  CacheControllerProvider,
  ThemeProvider as CPJProvider,
  MetaProvider,
  NotificationProvider,
  UserTypeEnum,
  WaitingIcon,
} from "@cpj-ai/panel-npm-package";
import { HeroUIProvider } from "@heroui/react";
import MainRoutes from "@routes/MainRoutes";
import { theme } from "@theme/index";
import { firebaseApp } from "@utils/firebaseApp";
import { Toaster } from "react-hot-toast";
import { RouterProvider } from "react-router-dom";

import "@cpj-ai/panel-npm-package/dist/esm/index.css";
import "@styles/index.css";
import "swiper/css";
import "swiper/css/pagination";

function App() {
  return (
    <CPJProvider theme={theme}>
      <HeroUIProvider locale="en-GB">
        <ApolloProvider client={apolloClient}>
          <MetaProvider metaFileName={import.meta.env.VITE_PUBLIC_META_FILE_NAME} />
          {import.meta.env.VITE_PUBLIC_REFRESH_ON_VERSION_CHANGE && <CacheControllerProvider />}
          <NotificationProvider firebaseApp={firebaseApp} userType={UserTypeEnum.ORG} />
          <RouterProvider router={MainRoutes} />
          <Toaster
            toastOptions={{
              position: "bottom-center",
              duration: 5000,
              loading: {
                icon: <WaitingIcon width={20} fill="#F5A524" />,
              },
            }}
          />
        </ApolloProvider>
      </HeroUIProvider>
    </CPJProvider>
  );
}

export default App;
